import { AppUser } from '../users/types';

/*
 * Action Types
 */
export enum OrdersTypes {
  CREATE_ORDER_REQUEST = '@orders/CREATE_ORDER_REQUEST',
  CREATE_ORDER_SUCCESS = '@orders/CREATE_ORDER_SUCCESS',
  CREATE_ORDER_FAILURE = '@orders/CREATE_ORDER_FAILURE',

  LIST_ORDERS_REQUEST = '@orders/LIST_ORDERS_REQUEST',
  LIST_ORDERS_SUCCESS = '@orders/LIST_ORDERS_SUCCESS',
  LIST_FULL_ORDERS_SUCCESS = '@orders/LIST_FULL_ORDERS_SUCCESS',
  LIST_ORDERS_FAILURE = '@orders/LIST_ORDERS_FAILURE',

  ASYNC_LIST_ORDERS_REQUEST = '@orders/ASYNC_LIST_ORDERS_REQUEST',
  ASYNC_LIST_ORDERS_SUCCESS = '@orders/ASYNC_LIST_ORDERS_SUCCESS',
  ASYNC_LIST_FULL_ORDERS_SUCCESS = '@orders/ASYNC_LIST_FULL_ORDERS_SUCCESS',
  ASYNC_LIST_ORDERS_FAILURE = '@orders/ASYNC_LIST_ORDERS_FAILURE',

  DELETE_ORDER_REQUEST = '@orders/DELETE_ORDER_REQUEST',
  DELETE_ORDER_SUCCESS = '@orders/DELETE_ORDER_SUCCESS',
  DELETE_ORDER_FAILURE = '@orders/DELETE_ORDER_FAILURE',

  GET_ORDER_REQUEST = '@orders/GET_ORDER_REQUEST',
  GET_ORDER_SUCCESS = '@orders/GET_ORDER_SUCCESS',
  GET_ORDER_FAILURE = '@orders/GET_ORDER_FAILURE',

  GET_ORDER_PDF_REQUEST = '@orders/GET_ORDER_PDF_REQUEST',
  GET_ORDER_PDF_SUCCESS = '@orders/GET_ORDER_PDF_SUCCESS',
  GET_ORDER_PDF_FAILURE = '@orders/GET_ORDER_PDF_FAILURE',

  FILTER_ORDER_REQUEST = '@orders/FILTER_ORDER_REQUEST',
  FILTER_ORDER_SUCCESS = '@orders/FILTER_ORDER_SUCCESS',
  FILTER_ORDER_FAILURE = '@orders/FILTER_ORDER_FAILURE',

  CHARGE_REQUEST_PAY_BOLETO_ORDER_REQUEST = '@orders/CHARGE_REQUEST_PAY_BOLETO_ORDER_REQUEST',
  CHARGE_REQUEST_PAY_BOLETO_ORDER_SUCCESS = '@orders/CHARGE_REQUEST_PAY_BOLETO_ORDER_SUCCESS',
  CHARGE_REQUEST_PAY_BOLETO_ORDER_FAILURE = '@orders/CHARGE_REQUEST_PAY_BOLETO_ORDER_FAILURE',

  CHARGE_REQUEST_PAY_ORDER_REQUEST = '@orders/CHARGE_REQUEST_PAY_ORDER_REQUEST',
  CHARGE_REQUEST_PAY_ORDER_SUCCESS = '@orders/CHARGE_REQUEST_PAY_ORDER_SUCCESS',
  CHARGE_REQUEST_PAY_ORDER_FAILURE = '@orders/CHARGE_REQUEST_PAY_ORDER_FAILURE',

  CHARGE_REQUEST_REPEAT_ORDER_REQUEST = '@orders/CHARGE_REQUEST_REPEAT_ORDER_REQUEST',
  CHARGE_REQUEST_REPEAT_ORDER_SUCCESS = '@orders/CHARGE_REQUEST_REPEAT_ORDER_SUCCESS',
  CHARGE_REQUEST_REPEAT_ORDER_FAILURE = '@orders/CHARGE_REQUEST_REPEAT_ORDER_FAILURE',
}

/*
 * Data types
 */
export interface PayamentInterface {
  type: string;
  data: object;
}

export interface OrderUsers {
  value: number;
  userDocument?: string;
  userId?: string;
}

export interface OrderInterface {
  transportOperatorId?: string;
  payment: PayamentInterface;
  orders: OrderUsers[];
}

export interface ChargeRequestOrderInterface {
  id: string;
  userId: string;
  status: number;
  value: number;
  User?: AppUser;
  benefits?: { Estudante: number; VT: number };
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
  transportOperatorId?: string;
}

export interface DataObjectInterface {
  data: {
    status: string;
    calendario: {
      expiracao: string;
      criacao: string;
    };
    location: string;
    txid: string;
    revisao: string;
    valor: {
      original: string;
    };
    chave: string;
    solicitacaoPagador: string;
    infoAdicionais: any[];
  };
}

export interface PaymentRequestHistory {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  paymentRequestId: string;
}
export interface CompanyPaymentRequestHistoriesInterface
  extends PaymentRequestHistory {
  companyPaymentRequestId: string;
}

export interface PaymentRequestInterface {
  id: string;
  type: string;
  status: number;
  value: number;
  tax: number;
  data: any;
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
  PaymentRequestHistories: PaymentRequestHistory[];
  authUserId?: string;
  TransportSupervisor?: {
    id: string;
    name: string;
  };
}

export interface CompanyPaymentRequestsInterface {
  id: string;
  companyId: string;
  amount: number;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  status: number;
  paymentRequestId: string;
  description: string;
  PaymentRequestHistories: CompanyPaymentRequestHistoriesInterface[];
}

export interface ChargeRequestHistory {
  id: string;
  fromStatus: number;
  toStatus: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  chargeRequestId: string;
}

export interface ChargeRequestInterface {
  id: string;
  invoiceId?: string;
  userId: string;
  type: string;
  status: number | string;
  value: number;
  nsu: number | null;
  ChargeRequestOrders: ChargeRequestOrderInterface[];
  createdAt: string;
  updatedAt: string;
  PaymentRequest: PaymentRequestInterface;
  ChargeRequestHistories: ChargeRequestHistory[];
  paymentStatus?: string;
  paymentType?: string;
  userName?: string;
  transportOperatorId?: string;
  photoUrl?: string;
  psp?: string;
}

/*
 * State type
 */
export interface OrdersState {
  readonly ordersList: OrderInterface[];
  readonly orderData: OrderInterface;
  readonly chargeRequestList: ChargeRequestInterface[];
  readonly chargeRequestListFull: ChargeRequestInterface[];
  readonly chargeRequestData: ChargeRequestInterface;
  readonly chargeRequestRepeatData: ChargeRequestInterface;
  readonly chargeBoleto: string;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
